enum SharkButtons {
    JAWS_3 = "jaws3",
    JAWS_4 = "jaws4",
    JAWS_G = "jawsG"
}

export default SharkButtons